<template>
    <ul class="l-ss-c-completions-tags-group">
        <li
            v-for="(tag, index) in sortedTags"
            :key="`tag-${tag.label}`"
            class="l-ss-c-completions-tags"
            @mousedown.prevent="handleTagsClick($event, tag, index)"
            v-html="tag.label">
        </li>
    </ul>
</template>
<script>
    export default {
        props: {
            data: {
                type: Array,
                default: () => ([]),
            },
            isTapsComplitions: {
                type: Boolean,
                default: false,
            },
            query: {
                type: String,
                default: '',
            },
            count: {
                type: Number,
            },
        },
        computed: {
            sliceTags() {
                return this.data.slice(0, this.count);
            },
            sortedTags() {
                const tags = [...this.sliceTags];

                return tags.sort((a, b) => b.label.length - a.label.length);
            },
        },
        mounted() {
            this.adjustVisibleTags();
        },
        updated() {
            this.adjustVisibleTags();
        },
        methods: {
            handleTagsClick(event, tag, index) {
                const query = tag.query;

                const formatTags = this.sortedTags.map(tag => tag.query);

                const trackParams = {
                    pos: index + 1,
                    selectTag: tag.query,
                    tags: formatTags,
                    event,
                };

                this.$emit('handle-tags-click', query);

                if (!this.isTapsComplitions) {
                    this.$emit('result-tab-click', {
                        type: 'resultTabClick',
                        ...trackParams,
                    });
                } else {
                    this.$emit('preview-tab-click', {
                        type: 'previewTabClick',
                        ...trackParams,
                    });
                }
            },
            adjustVisibleTags() {
                if (this.$screen.isMobile) {
                    return;
                }

                this.$nextTick(() => {
                    const GAP = 12;
                    const container = this.$el;
                    const containerWidth = container.offsetWidth;
                    const tags = container.querySelectorAll('.l-ss-c-completions-tags');

                    if (tags.length === 0) return;

                    let firstRowHeight = tags[0].offsetHeight;
                    let secondRowHeight = 0;
                    let width = 0;

                    for (const tag of tags) {
                        width += tag.offsetWidth + GAP;

                        if (width > containerWidth) {
                            secondRowHeight = tag.offsetHeight;
                            break;
                        }
                    }

                    this.$el.style.maxHeight = `${firstRowHeight + secondRowHeight + GAP * 2}px`;
                });
            },
        },
    };
</script>
